var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentRejectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.21582 3.12876C8.12176 2.95708 7.87824 2.95708 7.78418 3.12876L2.03143 13.6281C1.94 13.7949 2.059 14 2.24725 14H13.7528C13.941 14 14.06 13.7949 13.9686 13.6281L8.21582 3.12876ZM7.25039 10.3V7H8.75039V10.3H7.25039ZM8 12.8C7.50294 12.8 7.1 12.3971 7.1 11.9C7.1 11.4029 7.50294 11 8 11C8.49706 11 8.9 11.4029 8.9 11.9C8.9 12.3971 8.49706 12.8 8 12.8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentRejectedIcon);
export default __webpack_public_path__ + "static/media/document-rejected-icon.a47f13fe7d7f361a7bf8fe733ba242c3.svg";
export { ForwardRef as ReactComponent };